// Start Hotwire Turbo
import "@hotwired/turbo-rails";

// Start Stimulus
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Eagerly load all controllers from the controllers directory
const controllers = import.meta.glob("../controllers/**/*_controller.js", {
  eager: true,
});

// Register controllers using stimulus-vite-helpers
registerControllers(application, controllers);
